import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select/src/tom-select.popular'
import { TomInput, TomOption } from 'tom-select/src/types'
import { escape_html } from 'tom-select/src/utils'
import removeButton from 'tom-select/src/plugins/remove_button/plugin'

TomSelect.define('remove_button', removeButton)

const chevronIcon =
  '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-5">' +
  '<path stroke-linecap="round" stroke-linejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />' +
  '</svg>'

interface UserTomOption extends TomOption {
  avatar: string
  text: string
}

export default class extends Controller {
  static values = {
    keepLastValue: { type: Boolean, default: false },
    icon: { type: Boolean, default: false }
  }

  declare keepLastValueValue: boolean
  declare iconValue: boolean
  plugin: TomSelect

  connect (): void {
    this.initTomSelect()
  }

  private initTomSelect (): void {
    const isMultiple = (this.element as HTMLSelectElement).multiple

    this.plugin = new TomSelect(
      this.element as TomInput, {
        plugins: isMultiple ? ['remove_button'] : [],
        onDelete: (values: string[]) => {
          if (!this.keepLastValueValue) return true
          return (this.plugin.items.length - values.length) > 0
        },
        render: {
          option: (data: UserTomOption, escape: typeof escape_html) => (
            `<div><span class="relative pr-1 inline-flex">${data.avatar}</span> ${escape(data.text)}</div>`
          ),
          item: (data: UserTomOption, escape: typeof escape_html) => (
            `<div><span class="relative pr-1 inline-flex">${data.avatar}</span> ${escape(data.text)}</div>`
          )
        }
      }
    )

    if (this.iconValue) {
      this.plugin.wrapper.classList.add('with-chevron')
      if (this.plugin.control.querySelector('.ts-chevron') == null) {
        this.plugin.control.insertAdjacentHTML('beforeend', `<span class="ts-chevron">${chevronIcon}</span>`)
      }
    }
  }
}
